// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderDetailsAddressModalStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsAddressModal";
import { modalButtonsActionStyles } from "@tps/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsAddressModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

savedOrderDetailsAddressModalStyles.modal = {
    size: 600,
};

savedOrderDetailsAddressModalStyles.orderCustomerInformationGridContainer = {
    gap: 15,
    css: css`
        padding-left: 30px;
        margin: 12px 0 10px 0;
    `,
};

savedOrderDetailsAddressModalStyles.sessionCustomerInformationGridContainer = {
    gap: 15,
    css: css`
        padding-left: 30px;
        margin: 12px 0 10px 0;
    `,
};

savedOrderDetailsAddressModalStyles.sessionBillingInformationGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        order: 0;
    `,
};

savedOrderDetailsAddressModalStyles.orderBillingInformationGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        order: 0;
    `,
};

savedOrderDetailsAddressModalStyles.sessionAddressSelectText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
        line-height: 17px;
    `,
};

savedOrderDetailsAddressModalStyles.orderAddressSelectText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
        line-height: 17px;
    `,
};
